<div class="deleteDialog">
  <sync-dialog [config]="
  {
  title: 'Delete my Sync account', 
  isClosable: false, 
  actionButton: 'Delete', 
  cancelButton: 'Cancel',
  onActionClick: deleteSyncAccount,
  onCancelClick: closeDeleteDialog,
  isButtonLoading: isSaveButtonLoading
  }" [isCritical]="true" [open]="showDeleteDialog" [isFullScreen]="false" [onClose]="closeDeleteDialog">
  <form id="dialog-cancel-modal" class="delete-wrapper" [formGroup]="cancelForm" method="post" ngNativeValidate>
     <app-error [errcode]="errcode"></app-error>
     <div *ngIf="formErrorMessage">
        <sync-alert
        [type]="'critical'"
        [showLeadIcon]="true"
        [leadIcon]="'error'"
        [title]="''"
        [description]="formErrorMessage"
        [showActions]="false"
        [showPrimaryAction]="false" 
        [showSecondaryAction]="false"
        [showCloseButton]="false"
        ></sync-alert>
     </div>
     <div class="delete-container">
         <div>
            Thanks for trying Sync. Before leaving, we'd like to learn how we can make the product better.
         </div>
        <sync-select label="Reason" [list]="reasonList" [onSelectionChange]="onSelectionChange" [errorMsg]="reasonError"></sync-select>
        <sync-select *ngIf="cancelForm?.controls?.mainReason?.value"
            label="Specific Reason"
            [list]="specificReasonList"
            [onSelectionChange]="onSpecificReasonChange"
            [errorMsg]="specificReasonError"
         ></sync-select>
        <sync-text-field label="Additional feedback" placeholder="Additional feedback" [inputChange]="getDescription" [errorMessage]="descriptionError"></sync-text-field>
        <sync-checkbox 
        [label]="'I understand that closing my account will permanently delete all account data, including all encrypted file data stored in the cloud. I confirm that I have a local copy of my data'" 
        [onChange]="getTermsValue"
        [error]="termsError ? true : false"
        [errorMessage]="termsError"
        ></sync-checkbox>
     </div>
  </form>
  </sync-dialog>
</div>